import { mono } from "src/fonts";
import { dimensions, SvgIconProps } from "./SvgIcon";
import { theme } from "antd";

export const MetricIcon = (props: SvgIconProps & { inactive?: boolean }) => {
  const { token } = theme.useToken();
  const { width, height } = dimensions(props);
  return (
    <svg
      style={{ display: "block", ...props.style }}
      width={width}
      height={height}
      viewBox="0 0 20 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.9">
        <path
          d="M3 13V2.14313H4.79578L8.97747 9.61253H9.06395V2.14313H10.8801V13H9.10974L4.91279 5.55711H4.82631V13H3ZM12.274 10.4925V9.26795H16.7711V10.4925H12.274ZM14.5174 7.7253C14.0053 7.7253 13.561 7.61044 13.1846 7.38072C12.8115 7.151 12.5233 6.83823 12.3198 6.44241C12.1163 6.04659 12.0145 5.59775 12.0145 5.0959V4.6294C12.0145 4.13108 12.1163 3.68402 12.3198 3.28819C12.5233 2.88884 12.8115 2.5743 13.1846 2.34458C13.5577 2.11486 13.9985 2 14.5073 2C15.0228 2 15.4654 2.11486 15.835 2.34458C16.2081 2.5743 16.4947 2.88884 16.6948 3.28819C16.8983 3.68402 17 4.13108 17 4.6294V5.0959C17 5.59422 16.9 6.04129 16.6999 6.43711C16.5031 6.83293 16.2183 7.14747 15.8452 7.38072C15.4755 7.61044 15.0329 7.7253 14.5174 7.7253ZM14.5174 6.4106C14.8396 6.4106 15.0889 6.29221 15.2653 6.05542C15.445 5.8151 15.5349 5.49526 15.5349 5.0959V4.6294C15.5349 4.23357 15.4467 3.91904 15.2703 3.68578C15.094 3.45253 14.8396 3.3359 14.5073 3.3359C14.1783 3.3359 13.9256 3.45253 13.7493 3.68578C13.5763 3.91904 13.4898 4.23357 13.4898 4.6294V5.0959C13.4898 5.49526 13.578 5.8151 13.7544 6.05542C13.9307 6.29221 14.1851 6.4106 14.5174 6.4106Z"
          fill={token.colorText}
        />
      </g>
    </svg>
  );
};
